import React, { useEffect, useState } from 'react';
import { actions } from 'redux/actions';
import { service } from 'services';
import { createLink, getKey } from 'utils';
import { ACTIONS_TYPES } from 'redux/helper';
import { ROUTE } from 'constant';
import Shared from 'screens/shared';
import { useSelector } from 'react-redux';
import { form } from 'types';
import { validateForm } from 'utils/form-validation';
import { _t } from 'utils/translation';
import { createRegistryForm } from '../config';

export const List = ({ history }) => {
  const {
    [ACTIONS_TYPES.CONTAINER_REGISTRY.REGISTRY.GET_ALL]: registries = [],
    [ACTIONS_TYPES.CONTAINER_REGISTRY.LOCATION.GET_ALL]: locations = [],
  } = useSelector((e) => e);

  const [nameAvailabilityError, setNameAvailabilityError] = useState('');

  useEffect(() => {
    actions.containerRegistry.registry.getAll();
    actions.containerRegistry.location.getAll();
  }, []);

  const validateName = (name) => {
    const { validations } = createRegistryForm({});
    const validForm = validateForm({ validations, fields: [{ name: 'name' }], fieldsValues: { name } });
    return Object.keys(validForm).length === 0;
  };

  const addHandler = async (properties) => {
    if (!nameAvailabilityError) {
      actions.containerRegistry.registry.create({ properties }).then((result) => {
        if (getKey('isAccessByDCD') && !result.httpStatus) {
          setTimeout(() => {
            actions.containerRegistry.registry.getAll();
          }, 2000);
        }
      });
    }
  };

  const handleNameChange = async (event) => {
    const name = event.target.value;
    const validName = validateName(name);
    if (!validName) {
      setNameAvailabilityError('');
      return;
    }
    const { httpStatus } = await service.containerRegistry.registry.checkNameAvailability({ name });
    if (httpStatus === 404) {
      setNameAvailabilityError('');
    } else {
      setNameAvailabilityError(_t('CONTAINER_REGISTRY.NAME_NOT_AVAILABLE'));
    }
  };

  return (
    <Shared.widgets.Page route={ROUTE.DASHBOARD.CONTAINER_REGISTRY_LIST} isStrap={false}>
      <Shared.widgets.Section
        sectionTitle={_t('CONTAINER_REGISTRY.REGISTRIES')}
        createForm={form({
          ...createRegistryForm({
            onNameChange: handleNameChange,
          }),
          changeFields: [
            { name: 'location', props: { values: locations?.map((e) => [e.id, <Shared.utilities.Location location={e?.id} />]) } },
            { name: 'name', props: { externalError: nameAvailabilityError } },
          ],
          submitTitle: _t('CONTAINER_REGISTRY.CREATE_REGISTRY'),
          onSubmit: addHandler,
          validateOnBlur: true,
        })}
        createActionType={ACTIONS_TYPES.CONTAINER_REGISTRY.REGISTRY.CREATE}
        setItemTitle={({ properties = {} }) => properties?.name}
        items={registries}
        setItemKey={(e) => e.id}
        setItemDetails={({ properties = {}, metadata = {} }) => (
          <>
            <Shared.utilities.Location location={properties?.location} />
            <Shared.utilities.Status className="m-l-15" state={metadata.state} />
          </>
        )}
        itemIcon="building"
        tableColumns={['', 'Name', 'Location / Host']}
        itemOnClick={(e) => history.push(createLink(ROUTE.DASHBOARD.CONTAINER_REGISTRY_SINGLE, { id: e?.id }))}
        refresh={() => actions.containerRegistry.registry.getAll()}
      />
    </Shared.widgets.Page>
  );
};
